import React, { useRef, useMemo, useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { Tooltip, Popconfirm, Checkbox,Spin, Avatar, Tag, Button, message, Affix, Row, Image, DatePicker, Pagination } from 'antd';
import { EditOutlined, CopyOutlined, DeleteOutlined, PhoneOutlined } from '@ant-design/icons';
import { BASE_URL, DateFormat, DateTimeFormat } from '../Components/Constant';
import { getUniqueColor } from '../Components/Utility';
import { useSelector } from "react-redux";
import DynamicSelectEditor from './DynamicSelectEditor';
import ApiService from '../Components/apiService';
import DateTimePickerEditor from './DateTimePickerEditor';
import MultiSelectPicker from './MultiSelectPicker';
import AddressPicker from './AddressPicker';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import { LookupCell } from './LookupCell';
// Custom renderers

export const GridViewTable = ({
  fieldsData,
  fetchCurrency,
  getConvertedValue,
  records,
  objectName,
  fetchRecords,
  handleLabelClick,
  handleCloneClick,
  handleEditClick,
  deleteRecord,
  totalRecords,
  pageSize,
  setPageSize,
  selectedListView,
  currentPage,
  keyword,
  objName,
  isGlobalSearch = false,
  fetchSingleObjectRecords,
  setCurrentPage,
  setLoading,
  loading
}) => {
  const gridRef = useRef();
  const [editingCell, setEditingCell] = useState(null);
  const [originalData, setOriginalData] = useState([]);
  const [recordsData, setRecordsData] = useState([]);
//   const [activeCurrencies,setActiveCurrencies] = useState([]);
    const [editedCells, setEditedCells] = useState([]);
    const [inlineEditing, setInlineEditing] = useState(false);
    const [modifiedData, setModifiedData] = useState({});
    const [columns, setColumns] = useState([]);
    const [currency, setCurrency] = useState('');
    const defaultCurrency = useSelector(state=>state.data.orgItem);
    const security=useSelector(state=>state.data.items[0]);

    const fetchOrgSetupDetails = async () => {
        setCurrency(defaultCurrency?.currency); 
    };

    useEffect(() => {
        fetchOrgSetupDetails();
    }, []);
    
    useEffect(() => {
        if (records) {
            setOriginalData([...records]); // Store a copy of the original data
            setRecordsData([...records]); // Initialize recordsData with the original data
        }
    }, [records]);

    useEffect(() => {
        fetchColumns();
        
    }, [fieldsData, records, inlineEditing]);

    useEffect(()=>{
        fetchCurrency();  // Fetch mt_currencies
    },[]);

    // useEffect(() => {
    //     // if (activeCurrencies.length > 0) {
    //         setLoading(true);
    //     }
    //   }, [activeCurrencies]);
      
    // const fetchCurrency = async () => {
    //     try {
    //         setLoading(true);
    //         const apiService = new ApiService(`${BASE_URL}/mt_currencies`, {
    //             'Content-Type': 'application/json',
    //         }, 'GET');
    //         const response = await apiService.makeCall();
    //         console.log('responseresponse:',response);
    //         setActiveCurrencies(response);
    //     } catch (err) {
    //         console.error("Error fetching metadata:", err);
    //     }finally{
    //         setLoading(false);
    //     }
    // }
    // const getConvertedValue = (amount, fromCode, toCode) => {
    //     const parsedAmount = parseFloat(amount);
      
    //     // Check for invalid or empty amount
    //     if (isNaN(parsedAmount) || fromCode === toCode) {
    //       return isNaN(parsedAmount) ? '0.00' : parsedAmount.toFixed(2);
    //     }
    //     const fromCurrency = activeCurrencies.find(c => c.iso_code === fromCode);
    //     const toCurrency = activeCurrencies.find(c => c.iso_code === toCode);
    //     console.log('activeCurrencies isss',activeCurrencies);
    //     console.log('fromCurrency',fromCurrency,toCurrency);
    //     if (!fromCurrency || !toCurrency || !fromCurrency.conversion_rate || !toCurrency.conversion_rate) {
    //       return '0.00';
    //     }
      
    //     const inCorporate = parsedAmount / fromCurrency.conversion_rate;
    //     const converted = inCorporate * toCurrency.conversion_rate;
      
    //     return converted.toFixed(2);
    //   };

    const fetchColumns = () => {
        
        const filteredFieldsData = (fieldsData).filter(
            field => !['recordCount', 'CreatedBy', 'LastModifiedBy'].includes(field.name)  
            // && field.type !== 'image'
        );
        
        const nameField = filteredFieldsData.find(field => field.name === 'Name');
        const otherFields = filteredFieldsData
            .filter(field => field.name !== 'Name' && !field.is_auto_number)
        const fieldsToShow = [nameField, ...otherFields].filter(Boolean); 

        const columns = fieldsToShow.map((field, index) => ({
            headerName: field.label,
            field: field.name,
            key: field.name,
            type: field.type,
            flex: (field.type === 'address' || field.type === 'multiselect' || field.type === 'image') ? 2 : 1,
            pinned: field.name === 'Name' ? 'left' : undefined,
            suppressMovable: field.name === 'Name',
            headerTooltip: field.label,
            tooltipValueGetter: (params) => {
                // const value = params.data?.[field.name];
                // // Suppress tooltip for objects or arrays
                // if (typeof value === "object") {
                //     return null; // no tooltip
                // }
                // return value;
                return null;
            },

        
            editable: (params) => {
                const name = field.name;
                const isFieldSecurityEditable = security?.object_settings?.[objectName]?.field_setting?.[name]?.edit;
                if (isFieldSecurityEditable === false) {
                    return false;
                }
                return field?.is_auto_number !== true && !field?.is_formula && field?.type !== 'image' && !field?.is_system
            },
            cellEditorPopup: field?.type === 'address' ? true : undefined,
            cellEditor: 
                field.type === 'date' ? 'agDateCellEditor' : 
                field.type === 'datetime' ? DateTimePickerEditor : 
                field.type === 'picklist' ? 'agSelectCellEditor' :
                field.type === 'multiselect' ? MultiSelectPicker :
                field.type === 'currency' ? 'agNumberCellEditor' :
                field.type === 'string' ? undefined :
                field.type === 'boolean' ? 'agCheckboxCellEditor' :
                field.type === 'integer' ? 'agNumberCellEditor' :
                field.type === 'email' ? undefined :
                field.type === 'url' ? undefined :
                field.type === 'phone' ? undefined :
                field.type === 'text' ? undefined :
                field.type === 'textarea' ? 'agLargeTextCellEditor' :
                field.type === 'richtext' ? 'agLargeTextCellEditor' :
                field.type === 'address' ? AddressPicker :
                field.type === 'lookup' ? DynamicSelectEditor :
                field.type === 'decimal' ? 'agNumberCellEditor' :
                field.type === 'percentage' ? 'agNumberCellEditor' :
                undefined,
                cellEditorParams: (params) => 
                    field.type === 'picklist' ? { values: ['', ...field.picklist_values.map(option => option)] } : 
                    field.type === 'lookup' ? { 
                        objectName: field.parent_object_name, 
                        lookupConfig: field.lookup_config,
                        fieldId: field._id, 
                        name: field.name, 
                        value: params?.data?.[field.name],
                        record: params?.data,
                    } :
                    field.type === 'multiselect' ? {
                        selectOptions: Array.isArray(field?.picklist_values)
                            ? field.picklist_values.map(opt =>
                                typeof opt === 'string'
                                    ? { label: opt, value: opt }
                                    : opt
                            )
                            : [],
                        value: Array.isArray(params?.data?.[field.name])
                            ? params?.data?.[field.name]
                            : params?.data?.[field.name]
                                ? [params?.data?.[field.name]]
                                : [],
                    } :
                    field.type === 'address' ? {
                        value: params?.data?.[field.name] || {},
                    } :
                    undefined,
            valueGetter: field.type === 'date'
                ? (params) => {
                    const val = params.data[field.name];
                    return val ? new Date(val) : null;
                }
                : 
                undefined,
            valueSetter: field.type === 'date'
                ? (params) => {
                    params.data[field.name] = params.newValue
                        ? dayjs(params.newValue).format('YYYY-MM-DD')
                        : '';
                    return true;
                }
                : 
                undefined,
            
            autoHeight: true,
            cellStyle: (field?.type === 'currency' || field?.type === 'rollup')
                ? { justifyContent: 'right', whiteSpace: 'normal', wordWrap: 'break-word', paddingRight: '30px' }
                : field?.type === 'lookup'
                    ? { justifyContent: 'flex-start', textAlign: 'left', whiteSpace: 'normal', wordWrap: 'break-word' }
                    : { whiteSpace: 'normal', wordWrap: 'break-word' },
            headerTooltip: field?.formula || field?.is_formula ? field?.formula : '',
            headerClass: 'custom-header-cell',
            filterValueGetter: field.type === 'lookup'
                ? (params) => params.data?.[field.name]?.Name || ''
                : undefined,
            comparator: field.type === 'lookup'
                ? (valueA, valueB, nodeA, nodeB) => {
                    // valueA and valueB are the lookup objects (or undefined)
                    const nameA = valueA?.Name?.toLowerCase?.() || '';
                    const nameB = valueB?.Name?.toLowerCase?.() || '';
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                }
                : undefined,
            cellRenderer: (params) => {
                
                if (index === 0 ) {
                        return (
                            <div
                                style={{ position: "relative", display: "flex", alignItems: "center" }}
                            >
<a
                                href={`/record/${objectName}/${params?.data._id}`}
                                target="_self"
                            >
                                {params?.data[field?.name]}
                            </a>                            </div>
                        );
                }
                else {
                    if (field.type === 'date') {
                        return params?.data?.[field?.name] ? dayjs(params?.data?.[field?.name]).format(DateFormat) : '';
                    }
                    else if (field.type === 'string') {
                        return params?.data?.[field?.name] || '';
                    }
                    else if (field.type === 'image') {
                        return params?.data?.[field?.name] ? (
                            <Image
                                src={params?.data?.[field?.name]}
                                width={ 80}
                                style={{ height:80 || 'auto', borderRadius: '8px' }}
                                alt="image"
                            />
                        ) : (
                            ''
                        )
                    }                    
                    else if (field.type === 'datetime') {
                        const dateInput = params?.data?.[field.name];
                        return dateInput && dayjs(dateInput).isValid()
                            ? dayjs(dateInput).format('DD/MM/YYYY hh:mm A')
                            : '';
                    }
                    else if (field.type === 'currency') {
                        const value = parseFloat(params?.data?.[field?.name]);
                        const recordCurrency = params?.data?.CurrencyIsoCode; // e.g., 'CAD'
                        const userCurrency = Cookies.get('userCurrency'); // fallback to login user currency if needed
                        
                        // const recordSymbol = currencySymbols[recordCurrency] || recordCurrency || '';
                        // const userSymbol = currencySymbols[userCurrency] || userCurrency || '';
                        
                        if (isNaN(value)) return ''; // Empty if not a number
                        
                        const convertedValue = getConvertedValue(value, recordCurrency, userCurrency);
                        
                        return (
                            <span>
                            {recordCurrency} {value.toFixed(2)}
                            {recordCurrency !== userCurrency && (
                                <span style={{ color: '#888', marginLeft: 8 }}>
                                ({userCurrency} {convertedValue})
                                </span>
                            )}
                            </span>
                        );
                    }
                    else if (field.type === 'rollup') {
                        return params?.data?.[field?.name] === 0 ? `0.00` : params?.data?.[field?.name] ? `${params?.data?.[field?.name]?.toFixed(2)}` : ''; // Format as currency with dollar sign
                    }
                    else if (field.type === 'percentage') {
                        return params?.data?.[field?.name] ? `${params?.data?.[field?.name]}%` : ''; // Format as currency with dollar sign
                    }
                    else if (field.type === 'decimal') {
                        const value = params?.data?.[field.name];
                        return value === undefined || value === null || value === '' || isNaN(value)
                            ? ''
                            : Number(value).toFixed(2);
                    } else if (field.type === 'email') {
                        return params?.data?.[field?.name] ? (
                            <a href={`mailto:${params?.data?.[field?.name]}`} target="_blank" rel="noopener noreferrer">
                                {params?.data?.[field?.name]}
                            </a>
                        ) : '';
                    } else if (field.type === 'url') {
                        return params?.data?.[field?.name] ? (
                            <a href={params?.data?.[field?.name].startsWith('http') ? params?.data?.[field?.name] : `http://${params?.data?.[field?.name]}`} target="_blank" rel="noopener noreferrer">
                                {params?.data?.[field?.name]}
                            </a>
                        ) : '';
                    } else if (field?.type === 'lookup') {
                        let lookupId = params?.data?.[field?.name]; // Safely access the field
                        const ob = field?.parent_object_name;

                        if (!isGlobalSearch && !lookupId?._id) {
                            return ''; // Return empty if lookupId or its _id is undefined
                        } else {
                            return <LookupCell lookupId={lookupId} field={field} ob={ob} />;
                          
                        }
                    }
                    else if (field.type === 'address') {
                        const address = params?.data[field?.name]; // Access the address object
                        
                        if (address) {
                            // Combine address fields into a single string
                            const { street, city, state, country, postal_code } = address;
                            return [
                                street,
                                city,
                                state,
                                country,
                                postal_code,
                            ].filter(Boolean).join(', '); // Join non-empty fields with a comma 
                        }
                        return ''; // Return an empty string if the address is not available
                    }
                    else if (field.type === 'phone' && params?.data[field?.name]) {
                        // Add PhoneOutlined for phone numbers

                        return (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <PhoneOutlined style={{ marginRight: 8 }} />

                                {params?.data?.[field?.name] || ''}
                            </div>
                        );
                    }
                    else if (field.type === 'richtext') {
                        return (
                            <div dangerouslySetInnerHTML={{ __html: params?.data?.[field?.name] }} />
                        );
                    } 
                    else if (field.type === 'multiselect') {
                        
                        // Check if text is an array (i.e., the MultiSelect field has multiple values)
                        return Array.isArray(params?.data?.[field?.name]) ? (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                {params?.data?.[field?.name].map((value, index) => (
                                    <Tag
                                        key={index}
                                        color={getUniqueColor(index)} // Get a unique color for each tag
                                        style={{
                                            fontSize: '14px', // Adjust font size for better readability
                                            padding: '6px 12px', // Adjust padding for larger size
                                            borderRadius: '8px', // Rounded corners for aesthetic appeal
                                            lineHeight: '1.5', // Adjust line height for better spacing
                                        }}
                                    >
                                        {value}
                                    </Tag>
                                ))}
                            </div>
                        ) : (
                            params?.data?.[field?.name] || ''
                        );
                    }
                    else if (field.type === 'picklist') {
                        const picklistValue = params?.data?.[field?.name];
                        const picklistOptions = field?.picklist_values || [];
                        const selectedOption = picklistOptions.find(option => option.value === picklistValue);
                        if (!picklistValue) return null;

                        return (
                                <Tag
                                    color={selectedOption ? selectedOption.color : 'default'}
                                    style={{
                                        fontSize: '14px',
                                        padding: '6px 12px',
                                        borderRadius: '8px',
                                        lineHeight: '1.5',
                                    }}
                                >
                                    {selectedOption ? selectedOption.label : picklistValue}
                                </Tag>
                        );
                    }
                    else if (field.type === 'integer') {
                        const value = params?.data?.[field.name];
                        return value === undefined || value === null || value === '' || isNaN(value)
                            ? ''
                            : Number(value);
                    }
                    else if (field.type === 'textarea') {
                        return (
                            params?.data?.[field?.name] || ''
                        );
                    }
                    else if (field.type === 'boolean') {
                        return (
                            <Checkbox
                                checked={params?.data?.[field?.name]}
                                disabled={true}
                                // onChange={(e) =>
                                //     saveEdit(params.record, field.name, e.target.checked)
                                // }
                            />
                        );
                    }
                    else if (field.type === 'formula' || field.is_formula) {
                        const value = params?.data?.[field?.name];

                        // Address object (street, city, state, country, postal_code)
                        if (value && typeof value === 'object' && !Array.isArray(value)) {
                            // Check if it's an address-like object
                            const addressKeys = ['street', 'city', 'state', 'country', 'postal_code', 'pincode'];
                            const addressParts = addressKeys.map(k => value[k]).filter(Boolean);
                            if (addressParts.length > 0) {
                                return addressParts.join(', ');
                            }
                            // If not address, stringify object
                            return JSON.stringify(value);
                        }

                        // Array (e.g., MultiSelect)
                        if (Array.isArray(value)) {
                            return (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                    {value.map((v, idx) => (
                                        <Tag
                                            key={idx}
                                            color={getUniqueColor(idx)}
                                            style={{
                                                fontSize: '14px',
                                                padding: '6px 12px',
                                                borderRadius: '8px',
                                                lineHeight: '1.5',
                                            }}
                                        >
                                            {typeof v === 'object' ? JSON.stringify(v) : String(v)}
                                        </Tag>
                                    ))}
                                </div>
                            );
                        }

                        // Boolean
                        if (typeof value === 'boolean') {
                            return <Checkbox checked={value} disabled />;
                        }

                        // Number (integer, decimal, currency, percentage)
                        if (typeof value === 'number') {
                            if (field.format === 'currency') {
                                return `${currency || '$'}${value.toFixed(2)}`;
                            }
                            if (field.format === 'percentage') {
                                return `${value}%`;
                            }
                            return value;
                        }

                        // Date or DateTime (try to parse)
                        if (typeof value === 'string' && dayjs(value).isValid()) {
                            if (field.format === 'datetime') {
                                return dayjs(value).format('DD/MM/YYYY hh:mm A');
                            }
                            if (field.format === 'date') {
                                return dayjs(value).format(DateFormat);
                            }
                        }

                        // String (Email, URL, etc.)
                        if (typeof value === 'string') {
                            // Email
                            if (value.includes('@') && value.includes('.')) {
                                return (
                                    <a href={`mailto:${value}`} target="_blank" rel="noopener noreferrer">
                                        {value}
                                    </a>
                                );
                            }
                            // URL
                            if (value.startsWith('http') || value.startsWith('www.')) {
                                return (
                                    <a href={value.startsWith('http') ? value : `http://${value}`} target="_blank" rel="noopener noreferrer">
                                        {value}
                                    </a>
                                );
                            }
                            // Default string
                            return value;
                        }

                        // Fallback: show as string
                        return value !== undefined && value !== null ? String(value) : '';
                    }
                }
            }
        }));

        if (!isGlobalSearch) {

        columns.push({
            headerName: 'Action',
            key: 'operation',
            pinned: 'right',
            width: 100,
            minWidth: 100,
            suppressMovable: true,
            filter: false,
            editable: false,
            cellRenderer: (params) => (
                <>
                    <Tooltip title="Edit">
                        <EditOutlined
                            onClick={() => handleEditClick(params?.data)}
                            style={{ marginRight: 8, fontSize: '14px', cursor: 'pointer' }}
                        />
                    </Tooltip>

                    <Tooltip title="Clone">
                        <CopyOutlined
                            onClick={() => handleCloneClick(params?.data)}
                            style={{ marginRight: 8, fontSize: '14px', cursor: 'pointer' }}
                        />
                    </Tooltip>

                    <Tooltip title="Delete">
                        <Popconfirm
                            title="Are you sure you want to delete this item?"
                            onConfirm={() =>deleteRecord(params?.data)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <DeleteOutlined style={{ color: 'red', marginRight: 2, fontSize: '14px', cursor: 'pointer' }} />
                        </Popconfirm>
                    </Tooltip>
                </>
            ),
        });
    }
        setColumns(columns);
    }

    const handleCancel = () => {
        fetchRecords(selectedListView, currentPage, pageSize); // Re-fetch records to reset any changes
        setRecordsData([...originalData]); // Reset the table data to the original data
        setModifiedData({});
        setEditedCells([]);
        setInlineEditing(false);

        // Ensure the grid refreshes with the updated data
        if (gridRef.current && gridRef.current.api) {
            const api = gridRef.current.api;
            api.setRowData([...originalData]);
            api.deselectAll(); // Optional: if selections were made
            api.refreshCells({ force: true, suppressFlash: true });
        }
    };

    const handleSave = async () => {
        setLoading(true);

        // Get all lookup field names
        const lookupFieldNames = fieldsData.filter(f => f.type === "lookup").map(f => f.name);

        // Transform lookup fields to just their _id before saving
        const transformLookupsToIds = (record) => {
            const newRecord = { ...record };
            lookupFieldNames.forEach(field => {
                if (newRecord[field] && typeof newRecord[field] === "object" && newRecord[field]._id) {
                    newRecord[field] = newRecord[field]._id;
                }
            });
            return newRecord;
        };

        const updates = Object.values(modifiedData).map(transformLookupsToIds);

        const body = {
            "object_name": objectName,
            "updates": updates
        };

        try {
            const apiService = new ApiService(`${BASE_URL}/bulk_update_records`, {
                'Content-Type': 'application/json',
            }, 'PUT', body);
            await apiService.makeCall();
            message.success('Records updated successfully');
            fetchRecords(selectedListView, currentPage);
            setModifiedData({});
            setEditedCells([]);
            setInlineEditing(false);
        } catch (error) {
            console.error("Error updating records:", error);
            const errorMessage = error && typeof error === 'object'
                ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to update record due to an unknown error';
            message.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
    resizable: true,
    sortable: true,
    minWidth: 120,
    cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '2px 4px', // Reduced padding
        whiteSpace: 'normal',
        wordWrap: 'break-word',
    },
    cellClassRules: {
        'edited-cell': (params) =>
        editedCells.some(
            (cell) =>
                cell.rowIndex === params.node.rowIndex &&
                cell.colId === params.column.getColId()
        ),
    },
}), [editedCells]);

return (
    <>
        <div className="ag-theme-alpine custom-ag-theme"
            style={{
                flex: "1 1 auto",
                overflow: "auto",
                height: "91%",
                display: "flex",
                flexDirection: "column",
                margin: 0,
                padding: 0,
                borderRadius: 12,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                background: "#f8fafc",
            }}>
                
            <AgGridReact
                ref={gridRef}
                rowData={recordsData}
                columnDefs={columns}
                defaultColDef={defaultColDef}
                animateRows={true}
                rowHeight={36}
                headerHeight={45}
                
                // rowSelection={{ mode: "multiRow" }}
                pagination={false}
                paginationPageSize={20}
                domLayout="normal" // Use 'normal' layout to avoid auto-expanding height
                overlayLoadingTemplate={
                loading ? '<Spin spinning={loading} size="large" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />' : null
                }
                onGridReady={(params) => {
                    // Removed sizeColumnsToFit() to allow fixed column widths
                }}
                onSelectionChanged={(event) => console.log("Row Selected!")}
                onCellValueChanged={(event) => {
               

                    const rowNode = event.node;
                    const colId = event.column.getColId();
                    const rowIndex = rowNode.rowIndex;
                    const newValue = event.newValue;
                    const oldValue = event.oldValue;
                  
                    const isSameValue = (a, b, type) => {
                        if (type === 'date' || type === 'datetime') {
                            if (!a && !b) return true;
                            if (!a || !b) return false;

                            const aTime = dayjs(a).startOf('second').valueOf();
                            const bTime = dayjs(b).startOf('second').valueOf();
                            return aTime === bTime;
                        }

                        if (type === 'address') {
                            
                            if ((!a || Object.keys(a).length === 0) && (!b || Object.keys(b).length === 0)) {
                                return true;
                            }
                            if (!a || !b) {
                                return false;
                            }

                            const allKeys = new Set([
                                ...Object.keys(a || {}),
                                ...Object.keys(b || {}),
                                'street', 'city', 'state', 'country', 'postal_code', 'pincode', 'postalcode'
                            ]);

                            const addressKeys = Array.from(allKeys);
                            const isEqual = addressKeys.every(key => {
                                const aVal = (a[key] || '').toString().trim();
                                const bVal = (b[key] || '').toString().trim();
                                const equal = aVal === bVal;
                                if (!equal) {
                                    console.log(`Address key ${key} differs: "${aVal}" vs "${bVal}"`);
                                }
                                return equal;
                            });
                            
                            return isEqual;
                        }

                        return (a === undefined || a === null ? '' : a) === (b === undefined || b === null ? '' : b);
                    };

                    const fieldType = columns.find(col => col.field === colId)?.type;

                    if (isSameValue(newValue, oldValue, fieldType)) return;

                    const id = rowNode.data._id;

                    // Track modified cell styling
                    const cell = { rowIndex, colId };
                    setEditedCells(prev => [...prev, cell]);

                    // Build up modified data payload
                    setModifiedData(prev => {
                        const existing = prev[id] || { _id: id };
                        return {
                            ...prev,
                            [id]: {
                                ...existing,
                                [colId]: newValue
                            }
                        };
                    });

                    event.api.refreshCells({
                        rowNodes: [rowNode],
                        columns: [colId],
                        force: true
                    });

                    setInlineEditing(true);
                }}
                // onCellEditingStarted={handleCellEditingStarted}
                // onCellEditingStopped={handleCellEditingStopped}
                getRowId={(params) => params?.data?.id || params?.data?._id}
                frameworkComponents={{ DynamicSelectEditor, DateTimePickerEditor }}
                tooltipShowDelay={50}
            />
        </div>
      <div style={{ margin: '8px 0', display: 'flex', justifyContent: 'flex-end', padding: 0 }}>
            <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={totalRecords}
                showSizeChanger
                pageSizeOptions={["10", "20", "50", "100"]}
                onChange={(page, size) => {
                    if (isGlobalSearch) {
                        fetchSingleObjectRecords(page, size);
                    } else {
                        fetchRecords(selectedListView, page, size);
                    }
                    setCurrentPage(page);
                    setPageSize(size);
                }}
                onShowSizeChange={(current, size) => {
                    setPageSize(size);
                    if (isGlobalSearch) {
                        fetchSingleObjectRecords(current, size);
                    } else {
                        fetchRecords(selectedListView, current, size);
                    }
                    setCurrentPage(current);
                }}
                showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                style={{ margin: 0, padding: 0 }}
            />
        </div>
        {inlineEditing && (
            <Affix offsetBottom={0}>
                <div
                    style={{
                        width: '100%',
                        padding: '4px 0',
                        background: 'rgba(240, 242, 245, 0.9)',
                        position: 'fixed',
                        bottom: '1px',
                        left: 20,
                        margin: 0
                    }}
                >
                    <Row justify="center" style={{ margin: 0, padding: 0 }}>
                        <Button onClick={handleCancel} style={{ marginRight: 6, padding: '0 8px', height: 24, minWidth: 50 }}>
                            Cancel
                        </Button>
                        <Button type="primary" onClick={handleSave} style={{ padding: '0 8px', height: 24, minWidth: 50 }}>
                            Save
                        </Button>
                    </Row>
                </div>
            </Affix>
        )}
        <style>
            {`
            .ag-theme-alpine .ag-cell, .ag-theme-alpine .ag-header-cell {
                padding: 2px 4px !important;
            }
            `}
        </style>
    </>
);
};